import { render, staticRenderFns } from "./BatchEditDialog.vue?vue&type=template&id=0f16d696&scoped=true&"
import script from "./BatchEditDialog.vue?vue&type=script&lang=ts&"
export * from "./BatchEditDialog.vue?vue&type=script&lang=ts&"
import style0 from "./BatchEditDialog.vue?vue&type=style&index=0&id=0f16d696&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f16d696",
  null
  
)

export default component.exports